<script setup>
const props = defineProps({
  text: Object,
  subtitle: String,
});
</script>

<template> 
  <section class="l-container p-section">
    <div class="p-section max-w-[1000px] p-lg 2xl:px-xl bg-black-light border-red border-l-4">
      <div class="mb-xl last:mb-0 font-bold text-2xl xl:text-3xl" v-html="text?.content"></div>
      <div class="mb-xl last:mb-0" v-html="subtitle"></div>
    </div>
  </section>
</template>

<style></style>
